import * as Yup from "yup";

const CMSSchema = Yup.object().shape({
	content: Yup.string().required("Required"),
});

export default CMSSchema;